import { Input, Button, Form as AntForm } from 'antd';
import styled from 'styled-components';
import { Controller, useFieldArray, Control } from 'react-hook-form';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

const { Item: FormItem } = AntForm;

const HSMSDynamicFormItem = styled(FormItem)`
  .ant-form-item-control-input-content {
    display: flex;
  }
  .dynamic-delete-button {
    margin-left: 10px;
    margin-top: 8px;
  }
`;

interface HSMSInputProps {
  label: string;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValues?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
}

export const HSMSDynamicInputForm = ({ label, name, control, defaultValues }: HSMSInputProps) => {
  const { fields, append, remove } = useFieldArray({ control, name });

  return (
    <div>
      {fields.map((item, index) => (
        <HSMSDynamicFormItem labelCol={{ span: 24 }} key={item.id} label={index === 0 ? label : ''}>
          <Controller as={<Input />} name={`${name}.${index}`} control={control} defaultValue={defaultValues[name]} />

          <div>
            {fields.length > 1 && (
              <MinusCircleOutlined
                className="dynamic-delete-button"
                onClick={() => {
                  remove(index);
                }}
              />
            )}
          </div>
        </HSMSDynamicFormItem>
      ))}

      <Button
        type="dashed"
        onClick={() => {
          append({});
        }}
      >
        <PlusOutlined /> Add field
      </Button>
    </div>
  );
};
